'use strict';

// import moment from 'angular-moment';

function DayFilter(moment) {
  return input => {
    const Week = ['日', '月', '火', '水', '木', '金', '土'];
    return Week[moment(input).day()];
  }
}

export default angular.module('leptonApp.DayFilter', [])
  .filter('dayFilter', ['moment', DayFilter])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/filter/day_filter/day.filter.js